// extracted by mini-css-extract-plugin
export default {"select":"Select_select__nzbek","selectLabel":"Select_selectLabel__ocRNC","selectInput":"Select_selectInput__r1seb"};